import { render, staticRenderFns } from "./ChartWidget.vue?vue&type=template&id=fb0a4f6e&scoped=true"
import script from "./ChartWidget.vue?vue&type=script&lang=ts"
export * from "./ChartWidget.vue?vue&type=script&lang=ts"
import style0 from "./ChartWidget.vue?vue&type=style&index=0&id=fb0a4f6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0a4f6e",
  null
  
)

export default component.exports